import TemplateAnimation from "./Components/Common/TemplateAnimation";
import DataLandingPage from "./Data/DataLandingPage";
import connectWithDispatch from "src/Hooks/connectWithDispatch";
import { DNA1_WORKFLOW } from "./Data/DNA1/DNA1Workflow";
import { DNA2_WORKFLOW } from "./Data/DNA2/DNA2Workflow";
import { EV_WORKFLOW } from "./Data/EDGEVERVE/EVWorkflow";
import { AI_TWIN_WORKFLOW } from "./Data/AI_TWIN/AiTwinWorkflow";

interface AppProps {
  currentPage: number;
}

const App = (props: AppProps) => {
  const { currentPage } = props;
  const templates = [
    {
      page: 1,
      type: "landing-page-template" as TemplateType,
      data: DataLandingPage,
    },
    ...DNA1_WORKFLOW,
    ...DNA2_WORKFLOW,
    ...AI_TWIN_WORKFLOW,
    ...EV_WORKFLOW,
  ];

  return (
    <>
      <TemplateAnimation currentPage={currentPage} templates={templates} />
    </>
  );
};

const mapStateToProps = (state: StateType) => {
  return {
    currentPage: state.appReducer.currentPage,
  };
};

export default connectWithDispatch(App, mapStateToProps);
